import { render, staticRenderFns } from "./PackageQuoteQuery.vue?vue&type=template&id=bb9bdafa&"
import script from "./PackageQuoteQuery.vue?vue&type=script&lang=js&"
export * from "./PackageQuoteQuery.vue?vue&type=script&lang=js&"
import style0 from "./PackageQuoteQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageQuoteQuery.vue"
export default component.exports